import Vue from 'vue'
import Router from 'vue-router'

import ProtocolNew from '@/views/local/ProtocolNew'
import LocalProtocols from '@/views/local/Protocols'
import LocalProtocolEdit from '@/views/local/ProtocolEdit'
import ApiProtocols from '@/views/api/Protocols'
import ApiProtocolEdit from '@/views/api/ProtocolEdit'
import Signature from '@/views/Signature'
import Login from '@/views/auth/Login'

import Users from '@/views/users/Users'
import UserEdit from '@/views/users/UserEdit'
import UserNew from '@/views/users/UserNew'

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({y: 0}),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      component: ApiProtocols,
      name: 'ApiProtocols'
    },
    {
      path: '/local/protocols/new',
      name: 'ProtocolNew',
      component: ProtocolNew
    },
    {
      path: '/local/protocols',
      component: LocalProtocols,
      name: 'LocalProtocols'
    },
    {
      path: '/local/protocols/:id',
      name: 'LocalProtocolEdit',
      component: LocalProtocolEdit
    },
    {
      path: '/protocols/:id',
      name: 'ApiProtocolEdit',
      component: ApiProtocolEdit
    },
    {
      path: '/local/protocols/:id/signature/:subject',
      name: 'Signature',
      component: Signature
    },
    {
      path: '/login',
      component: Login,
      name: 'Login'
    },
    {
      path: '/users',
      name: 'Users',
      component: Users
    },
    {
      path: '/users/new',
      name: 'UserNew',
      component: UserNew
    },
    {
      path: '/users/:id',
      name: 'UserEdit',
      component: UserEdit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/index.js